import ServiceBase from '@ekd/portal-connector/dist/Service';
import { ApiUrls } from '@root/common/types/apiUrls';

import { Subscription } from '@paywall/types';
import jsonpAdapter from 'axios-jsonp';

/**
 * @returns user subscription packages
 */
export function createGetSubscriptionService({ service }: { service: ServiceBase<ApiUrls> }) {
  return {
    async getSubscription(token?: string | null) {
      if (!token) {
        return null;
      }

      try {
        const apiProvider = service.createProvider('HTTP');
        apiProvider.selectAPI('orders-api');

        const data = await apiProvider.request<Subscription>({
          method: 'get',
          params: {
            hash: encodeURIComponent(token),
          },
          adapter: typeof window !== 'undefined' ? jsonpAdapter : undefined,
        });

        return data;
      } catch (error) {
        return null;
      }
    },
  };
}
